export default __webpack_public_path__ + "static/media/usher.3ff350d4.svg";